export { default as state } from './state'
export { default as actions } from './actions'
export { default as mutations } from './mutations'
export { default as getters } from './getters'

export const namespaced = true
